import styled, { css } from 'styled-components';
import { TOfficeHoursValidity } from 'types/e-visits';

export function getColorForStatus(status: TOfficeHoursValidity) {
  switch (status) {
    case 'active':
      return 'success';
    case 'inactive':
      return 'danger';
    case 'prepared':
      return 'warning';
    default:
      return 'default';
  }
}

export const OfficeHoursCS = styled.div<{ status?: TOfficeHoursValidity; disabled?: boolean }>`
  width: 100%;
  margin-bottom: 16px;
  background: #fff;
  border-radius: 16px;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
  box-shadow: ${({ theme }) => theme.shadows.low};

  .title {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.color.border.regular};

    &--text {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #181e34;
      opacity: 0.6;
    }

    &--office-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-left: 16px;
    }
  }

  .content {
    ${({ status }) =>
      status === 'inactive'
        ? css`
            opacity: 0.4;
          `
        : css`
            opacity: 1;
          `}

    .day-row {
      .day {
        padding: 16px 24px;
        color: ${({ theme }) => theme.color.tint.secondary};
        ${({ theme }) => theme.mappedTypography.body1.default};
      }

      .days {
        ${({ theme }) => theme.mappedTypography.body2.default};
      }

      .day,
      .days {
        border-bottom: 1px solid ${({ theme }) => theme.color.border.regular};
      }

      .times {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
      }

      .days {
        padding-right: 24px;
      }
    }
  }

  .footer {
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;
